<template>
  <LessonAccessesPage lessonAccessAccountType="ADVANCED_CLASS"/>
</template>
<script>
import LessonAccessesPage from "@/components/pages/LessonAccessesPage.vue";

export default {
  components: {LessonAccessesPage},
}
</script>
